export default __webpack_public_path__ + "static/media/report.05803880.png";